import { render } from "./projectList.vue?vue&type=template&id=237cb2d8&scoped=true"
import script from "./projectList.vue?vue&type=script&lang=js"
export * from "./projectList.vue?vue&type=script&lang=js"

import "./projectList.vue?vue&type=style&index=0&id=237cb2d8&lang=scss&scoped=true"
import "./projectList.vue?vue&type=style&index=1&id=237cb2d8&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237cb2d8"]])

export default __exports__